import { render, staticRenderFns } from "./CritterHeader.vue?vue&type=template&id=ed4a856c&"
import script from "./CritterHeader.vue?vue&type=script&lang=js&"
export * from "./CritterHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CritterHeader.vue"
export default component.exports